import { SdkScriptRow } from "src/settings/sdks/types";

export const MOCK_SDK_SCRIPTS: SdkScriptRow[] = [
  {
    id: "script-fingerprint",
    name: "Fingerprint",
    providerLabel: "Fingerprint",
    lastUpdatedLabel: "Nov 11, 2024 at 1:37 pm",
    createdAtLabel: "Nov 11, 2024 at 1:37 pm",
  },
  {
    id: "script-socure-di",
    name: "Socure Digital Intelligence",
    providerLabel: "Socure",
    lastUpdatedLabel: "Nov 11, 2024 at 1:37 pm",
    createdAtLabel: "Nov 11, 2024 at 1:37 pm",
  },
];
